import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router'
import LoginView from "../../LoginView.tsx";

export const Route = createFileRoute('/login/')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        redirect: search.redirect as string | undefined,
        social: search.social as string | undefined,
    }),
    component: RouteComponent,
})

function RouteComponent() {
    return <LoginView />
}
